import { AppstoreOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang, useModel } from '@umijs/max';
import { Popover } from 'antd';
import { useState } from 'react';
import { PORTALS } from '../../../config/portalConfig';
import iconNotification from '../../../public/icons/notification-header.svg';
import NotificationPopover from './NotificationPopover';

export type SiderTheme = 'light' | 'dark';

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href='https://pro.ant.design/docs/getting-started'
      target='_blank'
      rel='noreferrer'
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};

export const Notification: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const { currentUser, isMobile } = initialState || {};
  const [popoverOpen, setPopoverOpen] = useState(false);

  return (
    <Popover
      content={<NotificationPopover open={popoverOpen} onClose={() => setPopoverOpen(false)} />}
      trigger='click'
      open={popoverOpen}
      onOpenChange={setPopoverOpen}
      placement={isMobile ? 'bottom' : 'bottomLeft'}
      overlayClassName='notification-popover-overlay'
      overlayStyle={{ width: 400, maxHeight: 600 }}
      arrow={false}
      zIndex={10001}
    >
      <a
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '4px',
          fontSize: '18px',
          color: 'inherit',
          cursor: 'pointer',
          position: 'relative',
        }}
      >
        <img src={iconNotification} style={{ width: '21px', height: 'auto' }} />
        {/* @ts-ignore */}
        {currentUser?.unreadNotificationCount > 0 && (
          <span
            style={{
              position: 'absolute',
              top: '2px',
              right: '2px',
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: '#ff4d4f',
            }}
          />
        )}
      </a>
    </Popover>
  );
};

export const SystemPortal: React.FC = () => {
  const content = () => {
    return (
      <div className='system-portal-content'>
        {PORTALS.map(portal => (
          <a href={portal.path} key={portal.path}>
            <img src={portal.icon} />
            {portal.name}
          </a>
        ))}
      </div>
    );
  };

  return (
    <Popover content={content()} trigger='click'>
      <AppstoreOutlined
        style={{ fontSize: '22px', display: 'flex', alignItems: 'center', padding: '4px' }}
      />
    </Popover>
  );
};
